import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * UX-039 — wraps sonner in an explicit `aria-live="polite"` landmark so
 * screen readers announce toasts. Sonner's internal list already uses
 * `aria-live` per-toast; the outer region provides a stable landmark with
 * an accessible name.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <div
      role="region"
      aria-live="polite"
      aria-atomic="true"
      aria-label="Notificações"
    >
      {/* A4-A11y — assertive sibling region for error announcements.
          `toastError` / `notifyError` push messages here so SR interrupts. */}
      <div
        id="a11y-error-live-region"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className="sr-only"
      />
      <Sonner
        theme={theme as ToasterProps["theme"]}
        className="toaster group"
        toastOptions={{
          classNames: {
            toast:
              "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
            description: "group-[.toast]:text-muted-foreground",
            actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
            cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          },
        }}
        {...props}
      />
    </div>
  );
};

export { Toaster, toast };
